import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex align-center justify-center my-10 text-gray-300"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  class: "text-center bg-yellow-300 border border-yellow-600 rounded-xl mx-auto mb-3 px-5 py-2",
  style: {"max-width":"680px"}
}
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "text-xs" }, "Si deseas ver fechas posteriores, debes realizar la búsqueda específica del rango de fechas en el filtro", -1)
const _hoisted_5 = { class: "mb-2 flex items-end space-x-2" }
const _hoisted_6 = { class: "text-3xl" }
const _hoisted_7 = { class: "bg-secondary flex items-center justify-between px-2 py-1" }
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "text-center text-2xl mb-4" }, "Eliminar Guía", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { class: "text-center" }, "¿Seguro que deseas eliminar una guía?, esta acción NO se puede deshacer.", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "pt-4" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_table_filter = _resolveComponent("table-filter")
  const _component_ui_simple_input = _resolveComponent("ui-simple-input")
  const _component_excel_req = _resolveComponent("excel-req")
  const _component_ui_table = _resolveComponent("ui-table")
  const _component_ui_table_nav = _resolveComponent("ui-table-nav")
  const _component_ui_button = _resolveComponent("ui-button")
  const _component_ui_modal = _resolveComponent("ui-modal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (!_ctx.isMounted)
      ? (_openBlock(), _createBlock("div", _hoisted_1, " ...CARGANDO GUIAS "))
      : (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("p", null, "El display y filtro por defecto traen las datos de entre " + _toDisplayString(_ctx.dates.now) + " y " + _toDisplayString(_ctx.dates.before), 1),
            _hoisted_4
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode("p", _hoisted_6, _toDisplayString(_ctx.routeName), 1),
            (_ctx.userStoreState && _ctx.userStoreState.role !== 'CONSULTOR' && _ctx.userStoreState.role !== 'SUPERVISOR')
              ? (_openBlock(), _createBlock("p", {
                  key: 0,
                  class: "cursor-pointer",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'guides.create' })))
                }, "Crear"))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_table_filter, {
            onFilter: _ctx.onFilterRequest,
            onUnfilter: _ctx.unfilter
          }, null, 8, ["onFilter", "onUnfilter"]),
          _createVNode("div", _hoisted_7, [
            _createVNode("div", null, [
              _createVNode(_component_ui_simple_input, {
                ref: "singleGuiaSearchRef",
                label: "Buscar Guía",
                onInput: _cache[2] || (_cache[2] = (evt) => (_ctx.filter.guia = evt)),
                filterFn: _ctx.searchSingleGuide
              }, null, 8, ["filterFn"])
            ]),
            _createVNode(_component_excel_req, { cb: _ctx.requestReport }, null, 8, ["cb"])
          ]),
          _createVNode(_component_ui_table, {
            headers: _ctx.headers,
            clickable: true,
            actions: _ctx.actions,
            items: _ctx.items
          }, null, 8, ["headers", "actions", "items"]),
          _createVNode(_component_ui_table_nav, {
            initial: _ctx.itemsCount.initial,
            actual: _ctx.itemsCount.actual,
            total: _ctx.itemsCount.total,
            onCount: _ctx.onPagedRequest,
            onNext: _ctx.onPageRequest,
            onPrevious: _ctx.onPageRequest,
            perPage: _ctx.filter.qty,
            loading: _ctx.isLoading
          }, null, 8, ["initial", "actual", "total", "onCount", "onNext", "onPrevious", "perPage", "loading"])
        ])),
    _createVNode(_component_ui_modal, {
      modalState: _ctx.modalState,
      "onUpdate:modalState": _cache[4] || (_cache[4] = ($event: any) => (_ctx.modalState = $event))
    }, {
      default: _withCtx(() => [
        _hoisted_8,
        _hoisted_9,
        _hoisted_10,
        _createVNode(_component_ui_button, {
          label: "Eliminar",
          onClick: _ctx.deleteGuia,
          loading: _ctx.deleting
        }, null, 8, ["onClick", "loading"]),
        _createVNode("p", {
          class: "text-center text-yellow-800 py-2 select-none cursor-pointer hover:bg-gray-50 rounded-md transition-all duration-300",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.modalState = false))
        }, "Cancelar")
      ]),
      _: 1
    }, 8, ["modalState"])
  ], 64))
}